module.exports = __webpack_public_path__ + "img/mangoes-350x184.76b4e579.jpg";